import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchTopicOverview } from '@/slices/topicSlice';
import { content } from '@/components/Cluster/TopicTip';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview, fetchTopicOverview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchTopicOverview(clusterName);
    }
  }, [clusterName, fetchTopicOverview]);

  const items = [
    {
      title: 'Topic',
      icon: 'topic',
      info: (
        <>
          <CountUp end={overview.totalTopicPartitionCount} duration={0.4} />/
          <CountUp end={overview.totalTopicCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: content,
    },
    {
      title: '生产者',
      icon: 'producer',
      info: <CountUp end={overview.totalProducerOnlineCount} duration={0.4} />,
      unit: '个',
      tip: '在线个数',
    },
    {
      title: '消费者',
      icon: 'consumer',
      info: <CountUp end={overview.totalConsumerOnlineCount} duration={0.4} />,
      unit: '个',
      tip: '在线个数',
    },
    {
      title: '订阅',
      icon: 'subscription',
      info: (
        <>
          <CountUp end={overview.totalSubscriptionOnlineCount} duration={0.4} />/
          <CountUp end={overview.totalSubscriptionCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: (
        <div>
          <strong>
            订阅({overview.totalSubscriptionOnlineCount || 0}/{overview.totalSubscriptionCount || 0}
            )
          </strong>
          <li>{overview.totalSubscriptionOnlineCount || 0}代表在线订阅数。</li>
          <li>{overview.totalSubscriptionCount || 0}代表总订阅数。</li>
        </div>
      ),
    },
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.topic.overview,
    loading: state.topic.loading,
  }),
  {
    fetchTopicOverview,
  },
)(Summary);
